import { render, staticRenderFns } from "./CampaignFeed.vue?vue&type=template&id=e38053a6&scoped=true&"
import script from "./CampaignFeed.vue?vue&type=script&lang=js&"
export * from "./CampaignFeed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e38053a6",
  null
  
)

export default component.exports